import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../stores/store";
import { getNextEpgItemsAsync, playerUIActions } from "./playerUISlice";
import DateHelper from "../../helpers/dateHelper.ts";
import PlayerUIHelpers from "../../helpers/playerUIHelpers.ts";
import { IPlayerChannel } from "../../interfaces/player/IPlayerUIState.ts";
import PlayerChannel from "./PlayerChannel.tsx";

interface IProps {
    channels: IPlayerChannel[]
}

export const PlayerUIBottomBar = ({ channels }: IProps) => {
    // useAxiosInterceptor();
    const dispatch = useAppDispatch();
    const playerChannelListRef = useRef<HTMLDivElement>(null);
    const isMenuUIVisible = useAppSelector((state) => state.playerUI.isMenuUIVisible);
    const isBackgroundTaskRunnig = useAppSelector((state) => state.playerUI.isBackgroundTaskRunning);
    const selectedChannelIndex = useAppSelector((state) => state.playerUI.channelToChangeIndex);
    const markerBtn = useRef<HTMLButtonElement>(null);

    // scroll to actual channel while render
    if (isMenuUIVisible && !isBackgroundTaskRunnig) {
        PlayerUIHelpers.scrollToChannel(selectedChannelIndex, true);
    } else {
        setTimeout(() => {
            PlayerUIHelpers.scrollToChannel(selectedChannelIndex, false);
        }, 500);
    }

    useEffect(() => {
        const handleScrollEndEvent = () => {
            if (isBackgroundTaskRunnig) // wartosc zostaje ustawiona w reducer kiedy wykonuje sie initial run oraz gdy isMenuUIVisible zostaje ustawiony na false i kiedy kanal do zmianiany rozni sie od aktualnie wybranego kanalu
                dispatch(playerUIActions.setIsBackgroundTaskRunning(false));
            setTimeout(() => {
                dispatch(playerUIActions.setLastOperationType("NONE"));
            }, 10);
        }
        const scrollChannelElem = document.getElementById("scrollToChannel");
        scrollChannelElem?.addEventListener("scrollend", () => handleScrollEndEvent())
        return () =>
            scrollChannelElem?.removeEventListener("scrollend", () => handleScrollEndEvent())
    }, [isBackgroundTaskRunnig, dispatch]);

    useEffect(() => {
        const updateEpgList = () => {
            dispatch(playerUIActions.setIsBackgroundTaskRunning(true));
            channels.forEach((channel) => {
                const actualEpgIndex = channel.epgList.findIndex(x => x.start_timestamp <= DateHelper.GetDateTimeNowAsUnixTimespan() && x.stop_timestamp > DateHelper.GetDateTimeNowAsUnixTimespan());
                if (channel.epgList.length > 0 && (actualEpgIndex + 3 > channel.epgList.length) && channel.lastEpgId === 0) {
                    const lastEpgItem = channel.epgList[channel.epgList.length - 1];
                    dispatch(getNextEpgItemsAsync({
                        chId: channel.ch_id,
                        fromUnixTimeStamp: lastEpgItem.stop_timestamp,
                        limit: 3
                    }));
                }
            })
            dispatch(playerUIActions.setIsBackgroundTaskRunning(false));
        }

        let interval: NodeJS.Timeout;
        if (!isMenuUIVisible) {
            interval = setInterval(() => updateEpgList(), 30000);
        }
        return () => clearInterval(interval);
    }, [isMenuUIVisible, isBackgroundTaskRunnig, channels]);

    return (
        <div
            className={`hidden sm:flex absolute bottom-0 h-60 w-full bg-gradient-to-b from-transparent via-neutral-900/85 to-neutral-900 flex-col justify-end z-0 space-y-4 pb-4`}>
            {channels.length > 0 && <>
                <div className={"mt-6 h-[1px] bg-gradient-to-r from-transparent via-[#008DD2] to-transparent w-full"} />
                <div className={"relative flex justify-between space-x-4 pr-4"}>
                    <button ref={markerBtn}></button>
                    <div
                        id={"scrollChannel"}
                        ref={playerChannelListRef}
                        className={`grow overflow-hidden focus:outline-none`}
                    >
                        {channels[selectedChannelIndex] &&
                            <PlayerChannel channel={channels[selectedChannelIndex]} />}
                    </div>
                </div>
                <div className={"mb-6 h-[1px] bg-gradient-to-r from-transparent via-[#008DD2] to-transparent w-full"} />
            </>
            }
        </div>
    )
}
